import { toast } from "react-toastify";
import ConfirmDeleteModal from "../../../Layout/Components/ConfirmDeleteModal";
import { deleteRealokasi } from "../services";

toast.configure();

const DeleteRealokasiModal = ({
  isOpen,
  toggle,
  selectedRealokasi,
  refreshRealokasi,
  axiosInstance,
}) => {
  const handleDelete = async () => {
    await deleteRealokasi(axiosInstance, selectedRealokasi.id).then(() => {
      refreshRealokasi();
    });
  };

  return (
    <ConfirmDeleteModal
      title={"Anda yakin ingin menghapus realokasi yang dipilih?"}
      isOpen={isOpen}
      toggle={toggle}
      handleDelete={handleDelete}
    />
  );
};

export default DeleteRealokasiModal;
